import type { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

const FALLBACK = 'application/octet-stream';

/**
 * Axios types Content-Type as AxiosHeaderValue (string | number | boolean | string[] | AxiosHeaders).
 * Blob `{ type }` and regex checks expect a plain string.
 */
export function getContentTypeHeader(
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders | undefined,
): string {
  if (!headers) {
    return FALLBACK;
  }

  let raw: unknown;
  if (typeof headers.get === 'function') {
    raw = headers.get('content-type') ?? headers.get('Content-Type');
  }
  if (raw == null || raw === '') {
    const h = headers as Record<string, unknown>;
    raw = h['content-type'] ?? h['Content-Type'];
  }

  if (typeof raw === 'string' && raw.length > 0) {
    return raw;
  }
  if (Array.isArray(raw)) {
    const first = raw.find((x): x is string => typeof x === 'string' && x.length > 0);
    if (first) {
      return first;
    }
  }
  return FALLBACK;
}
